export const PLACEHOLDER_IMAGE = `${process.env.PUBLIC_URL || ''}/default-product.svg`;

async function fetchWikiThumbnail(term) {
  if (!term) return null;
  const query = encodeURIComponent(String(term).trim());
  const url = `https://en.wikipedia.org/api/rest_v1/page/summary/${query}`;
  try {
    const res = await fetch(url, { cache: 'force-cache' });
    if (!res.ok) return null;
    const json = await res.json();
    return json?.thumbnail?.source || json?.originalimage?.source || null;
  } catch (e) {
    return null;
  }
}

export function handleImageError(event, product) {
  const el = event.currentTarget;
  const terms = [
    product?.categorie_nom,
    product?.categorie?.nom,
    product?.categorie,
    product?.nom,
    product?.name,
  ].filter(Boolean);
  const term = terms[0] || 'agriculture';
  // avoid infinite loop: if current src already equals placeholder, stop
  if (!el || el.dataset.fallbackTried === '1') {
    el && (el.src = PLACEHOLDER_IMAGE);
    return;
  }
  el.dataset.fallbackTried = '1';
  fetchWikiThumbnail(term).then((thumb) => {
    if (thumb) el.src = thumb;
    else el.src = PLACEHOLDER_IMAGE;
  }).catch(() => { el.src = PLACEHOLDER_IMAGE; });
}
